// extracted by mini-css-extract-plugin
export const headerSection = "styles-module--headerSection--29hLU";
export const overlay = "styles-module--overlay--2-F1n";
export const primary = "styles-module--primary--2k02W";
export const secondary = "styles-module--secondary--3Y-01";